import { useState, useEffect, useRef } from "react";
import { Button, Input, Row, Col, Drawer, message, Spin, Alert } from "antd";
// import "./style.css";
import "antd/dist/antd.css";
import { LoadingOutlined } from "@ant-design/icons";
import Close from "../../assets/images/close-x.svg";
import User from "../../assets/images/User.svg";
import CancelArrow from "../../assets/images/cancelArrow.svg";
import { validOtpCoupon, sendOtpToUser } from "../../services";
import messages from "../../errors/messages.en-IN.json";

const DiscountApprovalModal = ({
  event,
  closeDiscountApproval,
  visible,
  setIsDiscountApproval,
  onApprovalGranted,
  selectedCoupon,
  setSelectedCoupon,
  couponCode,
  discountAmt,
  totalSTD,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedUser, setSelectedUser] = useState();
  const [loading, setLoading] = useState(false);
  const [user, setUsers] = useState(event[0].approvals);
  const [notes, setNotes] = useState();
  const [otp, setOtp] = useState(Array(6).fill(""));
  const inputsRef = useRef([]);
  const [otpError, setOtpError] = useState(false);
  const [otpEnableForUser, setOtpEnableForUser] = useState("");
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        inputsRef.current[0]?.focus();
      }, 100);
    }
  }, [visible]);

  const handleChange = (value, index) => {
    setOtpError(false);
    if (!/^[0-9]?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    setOtpError(false);
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };
  const handleApprove = async () => {
    const selectedItem = user.filter((item) => item.userId === selectedUser);
    if (!selectedItem || selectedItem.length === 0) {
      setErrorMessage("No user found. Please select a valid user.");
      return;
    }
    if (posConfig?.saveParkedBills === "Y") {
      onApprovalGranted(true);
    } else {
      if (selectedItem[0]?.pin === inputValue) {
        onApprovalGranted(true);
      } else if (selectedItem[0]?.enableOTP === "Y") {
        const otpValue = otp.join("");
        try {
          const validOtpResponse = await validOtpCoupon(selectedUser, otpValue, couponCode, selectedCoupon?.mPricingrulesId);
          const status = validOtpResponse.data.data.validOtp.status;
          if (status === "200") {
            onApprovalGranted(true);
            setTimeout(() => {
              setOtp(Array(6).fill(""));
              setIsDiscountApproval(false);
              setOtpEnableForUser("");
            }, 500);
          } else if (status === "201") {
            setOtpError(true);
          }
        } catch (err) {
          console.error(err);
          message.error(`${messages.info.invalid_otp}`);
        }
      } else {
        setErrorMessage("Incorrect PIN entered. Please check and enter the correct PIN.");
      }
    }
  };

  const sendOtp = async (userId, coupon, couponCode, discountAmt, totalStd) => {
    try {
      const otp = await sendOtpToUser(userId, coupon, couponCode, discountAmt, totalStd);
      const status = otp.data.data.sendOtpToUser.status;
      if (status === "200") {
      } else if (status === "201") {
        setOtpError(true);
      }
    } catch (err) {
      console.error(err);
      message.error(`${messages.info.sending_otp_failed}`);
    }
  };

  const handleReject = () => {
    onApprovalGranted(false);
    setIsDiscountApproval(false);
    setOtpEnableForUser("");
    localStorage.removeItem("discountAdditionalInfo");
    localStorage.removeItem("discountAppliedData");
  };

  const handleNumber = (value) => {
    if (selectedUser) {
      if (inputValue === "" && value === "x") {
        setInputValue("");
      } else if (value === "x") {
        setInputValue(inputValue.toString().substring(0, inputValue.toString().length - 1));
      } else if (value === "Clear") {
        setInputValue("");
      } else {
        setInputValue(`${inputValue}${value}`);
      }
      const pinInput = document.getElementById("pinInput");
      pinInput.focus();
    } else {
      message.error(`${messages.info.user_required}`);
    }
  };

  useEffect(async () => {
    if (visible && user.length === 1 && user[0]?.enableOTP === "Y") {
      const selectedUserId = user[0].userId;
      setSelectedUser(selectedUserId);
      setOtpEnableForUser("Y");
      await sendOtp(selectedUserId, selectedCoupon, couponCode, discountAmt, totalSTD);
      setTimeout(() => {
        inputsRef.current[0]?.focus();
      }, 100);
    }
  }, [visible]);

  useEffect(() => {
    if (inputValue === "") {
      setErrorMessage(!errorMessage);
    }
  }, [inputValue, user]);

  const pinInput = document.getElementById("pinInput");

  return (
    <Drawer
      closable={true}
      placement="bottom"
      title={
        <div style={{ display: "flex", alignItems: "center", height: "2vh", fontSize: "1vw" }}>
          {user[0]?.enableOTP === "Y" ? (
            <p style={{ fontSize: "1.5em", marginTop: "3vh", fontWeight: "500", color: "#0F0718", flex: 1, textAlign: "center" }}>Coupon Approval Needed</p>
          ) : (
            <p style={{ fontSize: "1.5em", marginTop: "3vh", fontWeight: "500", color: "#0F0718", flex: 1, textAlign: "center" }}>Discount Approval Needed</p>
          )}
          <img src={Close} onClick={handleReject} style={{ float: "right", cursor: "pointer", marginTop: "-3vh", marginRight: "-0.5vw", width: "1.5vw" }} />
        </div>
      }
      closeIcon={null}
      visible={visible}
      className="filter"
      bodyStyle={{ paddingBottom: 0, paddingTop: 0 }}
      onClose={handleReject}
      height="90vh"
    >
      <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} className="spinLoader" spin />} spinning={loading}>
        <Row>
          <Col span={12}>
            <Row gutter={[16, 16]}>
              <Col span={22} push={2} style={{ paddingLeft: "1.5vw", fontSize: "1vw" }}>
                <span style={{ fontSize: "1.25em", fontWeight: 500, color: "#0F0718" }}>Authorizer Selection</span>
                <span style={{ float: "right" }}></span>
              </Col>
              {user
                .sort((a, b) => a.userName.localeCompare(b.userName))
                .map((res) => (
                  <Col
                    span={10}
                    push={2}
                    style={{
                      background: selectedUser === res.userId ? "#cae5bd" : "#fff",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      margin: "0 1rem",
                      padding: "0rem 0.5rem",
                    }}
                    onClick={async () => {
                      if (res.enableOTP === "Y") {
                        setSelectedUser(res.userId);
                        setOtpEnableForUser(res.enableOTP);
                        await sendOtp(res.userId, selectedCoupon, couponCode, discountAmt, totalSTD);
                        pinInput?.focus();
                        setInputValue("");
                        setTimeout(() => {
                          inputsRef.current[0]?.focus();
                        }, 100);
                      } else {
                        setSelectedUser(res.userId);
                        setOtpEnableForUser(res.enableOTP);
                        pinInput?.focus();
                        setInputValue("");
                        setTimeout(() => {
                          inputsRef.current[0]?.focus();
                        }, 100);
                      }
                    }}
                  >
                    <img src={User} alt="" style={{ marginRight: "10px", height: "2.5rem", margin: "0.7rem 0 " }} />
                    <span style={{ marginLeft: "10px", margin: "0.7rem 0px 0.7rem 10px", fontSize: "1vw" }}>
                      <p style={{ margin: 0, fontWeight: 500, fontSize: "1em", color: "#0F0718" }}>{res?.userName}</p>
                      <span style={{ fontSize: "0.8em", fontWeight: 500, color: "#0F0718" }}>{res?.role}</span>
                    </span>
                  </Col>
                ))}
            </Row>
          </Col>
          {posConfig?.saveParkedBills === "Y" ? (
            <Col span={10} push={1} pull={1}>
              <Row style={{ paddingTop: "1%" }}>
                {/* {(user.length === 1 && user[0].enableOTP === "Y") || otpEnableForUser === "Y" ? (
                  <div></div>
                ) : (
                  <Col span={20} pull={2} push={2}>
                    <Input
                      style={{ width: "100%", borderRadius: "2px", height: "8.5vh" }}
                      size="large"
                      className="discount-value-input"
                      placeholder="Type to add a note"
                      value={notes}
                      onChange={(e) => {
                        setNotes(e.target.value);
                      }}
                    />
                  </Col>
                )} */}
                <Col
                  span={20}
                  pull={2}
                  push={2}
                  style={{
                    padding: "1.5% 0",
                    fontSize: "1vw",
                    marginTop: (user[0].enableOTP === "Y" && user.length === 1) || otpEnableForUser === "Y" ? (user[0].enableOTP === "Y" && otpError ? "38vh" : "50vh") : 0,
                  }}
                >
                  <Button
                    disabled={selectedUser ? false : true}
                    onClick={handleApprove}
                    htmlType="submit"
                    style={{
                      backgroundColor: "#2F3856",
                      color: "#fff",
                      width: "100%",
                      fontSize: "1.5em",
                      textAlign: "center",
                      fontWeight: "500",
                      borderRadius: "7px",
                      height: "8vh",
                    }}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Col>
          ) : (
            <Col span={10} push={1} pull={1}>
              <Row>
                <Col span={20} pull={2} push={2} style={{ fontSize: "1vw" }}>
                  {(user.length === 1 && user[0].enableOTP === "Y") || otpEnableForUser === "Y" ? (
                    <p style={{ marginBottom: "0.4rem", fontWeight: "500", fontSize: "1.25em", color: "#0F0718" }}>OTP:</p>
                  ) : (
                    <p style={{ marginBottom: "0.4rem", fontWeight: "500", fontSize: "1.25em", color: "#0F0718" }}>
                      PIN: {errorMessage && <span style={{ color: "red", textAlign: "center", fontWeight: 400, fontSize: "1.2vw" }}>{errorMessage}</span>}
                    </p>
                  )}
                  {(user.length === 1 && user[0].enableOTP === "Y") || otpEnableForUser === "Y" ? (
                    <>
                      <Row gutter={8} justify="left">
                        {otp.map((digit, idx) => (
                          <Col key={idx}>
                            <Input
                              maxLength={1}
                              value={digit}
                              ref={(el) => (inputsRef.current[idx] = el)}
                              onChange={(e) => handleChange(e.target.value, idx)}
                              onKeyDown={(e) => handleKeyDown(e, idx)}
                              style={{
                                width: 50,
                                height: 50,
                                textAlign: "center",
                                fontSize: 20,
                                borderRadius: 4,
                              }}
                            />
                          </Col>
                        ))}
                      </Row>
                      {otpError && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "3vh",
                          }}
                        >
                          <Alert
                            type="error"
                            message={<span style={{ color: "#991b1b" }}>Invalid OTP. Please check and try again.</span>}
                            showIcon
                            style={{
                              backgroundColor: "#fff1f0",
                              border: "1px solid #fecaca",
                              color: "#cf1322",
                              marginBottom: 20,
                              width: "70%",
                              height: 50,
                              borderRadius: "0.5rem",
                            }}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <Input
                      style={{ width: "100%", borderRadius: "2px", height: "8.5vh" }}
                      size="large"
                      className="discount-value-input"
                      placeholder="Enter value"
                      id="pinInput"
                      type="password"
                      onPressEnter={(e) => e.preventDefault()}
                      value={inputValue}
                      onChange={(e) => {
                        setInputValue(e.target.value);
                      }}
                    />
                  )}
                </Col>
              </Row>
              {(user.length === 1 && user[0].enableOTP === "Y") || otpEnableForUser === "Y" ? (
                <div></div>
              ) : (
                <Row style={{ padding: "1.5% 8.4% 0 8.48%", fontSize: "1vw" }} gutter={[8, 6]}>
                  <Col span={6}>
                    <button id="sm-amount-button1" className="amt-dial-btn-approve" onClick={(e) => handleNumber("1", e)}>
                      1
                    </button>
                  </Col>
                  <Col span={6}>
                    <button id="sm-amount-button2" className="amt-dial-btn-approve" onClick={(e) => handleNumber("2", e)}>
                      2
                    </button>
                  </Col>
                  <Col span={6}>
                    <button id="sm-amount-button3" className="amt-dial-btn-approve" onClick={(e) => handleNumber("3", e)}>
                      3
                    </button>
                  </Col>
                  <Col span={6}>
                    <button className="amt-dial-btn-approve" id="sm-amount-buttonRemove" onClick={(e) => handleNumber("x", e)}>
                      <img src={CancelArrow} style={{ height: "1rem" }} alt="back space" />
                    </button>
                  </Col>
                  <Col span={6}>
                    <button id="sm-amount-button4" className="amt-dial-btn-approve" onClick={(e) => handleNumber("4", e)}>
                      4
                    </button>
                  </Col>
                  <Col span={6}>
                    <button id="sm-amount-button5" className="amt-dial-btn-approve" onClick={(e) => handleNumber("5", e)}>
                      5
                    </button>
                  </Col>
                  <Col span={6}>
                    <button id="sm-amount-button6" className="amt-dial-btn-approve" onClick={(e) => handleNumber("6", e)}>
                      6
                    </button>
                  </Col>
                  <Col span={6}>
                    <button onClick={(e) => handleNumber("Clear", e)} id="sm-amount-addQuantity" className="amt-dial-btn-approve">
                      Clear
                    </button>
                  </Col>
                  <Col span={18}>
                    <Row gutter={[8, 6]}>
                      <Col span={8}>
                        <button id="sm-amount-button7" className="amt-dial-btn-approve" onClick={(e) => handleNumber("7", e)}>
                          7
                        </button>
                      </Col>
                      <Col span={8}>
                        <button id="sm-amount-button8" className="amt-dial-btn-approve" onClick={(e) => handleNumber("8", e)}>
                          8
                        </button>
                      </Col>
                      <Col span={8}>
                        <button id="sm-amount-button0" className="amt-dial-btn-approve" onClick={(e) => handleNumber("9", e)}>
                          9
                        </button>
                      </Col>
                      <Col span={8}>
                        <button id="sm-amount-button0" className="amt-dial-btn-approve" onClick={(e) => handleNumber("0", e)}>
                          0
                        </button>
                      </Col>
                      <Col span={8}>
                        <button id="sm-amount-button00" className="amt-dial-btn-approve" onClick={(e) => handleNumber("00", e)}>
                          00
                        </button>
                      </Col>
                      <Col span={8}>
                        <button id="sm-amount-button." className="amt-dial-btn-approve" onClick={(e) => handleNumber(".", e)}>
                          .
                        </button>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={6}>
                    <button disabled={selectedUser ? false : true} id="sm-amount-buttonEnter" className="amt-dial-btn-approve2" onClick={handleApprove}>
                      Enter
                    </button>
                  </Col>
                </Row>
              )}
              <Row style={{ paddingTop: "1%" }}>
                {(user.length === 1 && user[0].enableOTP === "Y") || otpEnableForUser === "Y" ? (
                  <div></div>
                ) : (
                  <Col span={20} pull={2} push={2}>
                    <Input
                      style={{ width: "100%", borderRadius: "2px", height: "8.5vh" }}
                      size="large"
                      className="discount-value-input"
                      placeholder="Type to add a note"
                      value={notes}
                      onChange={(e) => {
                        setNotes(e.target.value);
                      }}
                    />
                  </Col>
                )}
                <Col
                  span={20}
                  pull={2}
                  push={2}
                  style={{
                    padding: "1.5% 0",
                    fontSize: "1vw",
                    marginTop: (user[0].enableOTP === "Y" && user.length === 1) || otpEnableForUser === "Y" ? (user[0].enableOTP === "Y" && otpError ? "38vh" : "50vh") : 0,
                  }}
                >
                  <Button
                    disabled={selectedUser ? false : true}
                    onClick={handleApprove}
                    htmlType="submit"
                    style={{
                      backgroundColor: "#2F3856",
                      color: "#fff",
                      width: "100%",
                      fontSize: "1.5em",
                      textAlign: "center",
                      fontWeight: "500",
                      borderRadius: "7px",
                      height: "8vh",
                    }}
                  >
                    Approve
                  </Button>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </Spin>
    </Drawer>
  );
};

export default DiscountApprovalModal;
